export const ADMIN_ROUTE_PATH =
  process.env.REACT_APP_ADMIN_PATH || "/vault-ax7k4d-labs";

export const ADMIN_PASSPHRASE = "Herdhorns";

